export const Pokedex: {[k: string]: ModdedSpeciesData} = {};
